module.exports = __webpack_public_path__ + "static/media/Finance.65a83212.svg";